export default __webpack_public_path__ + "assets/images/b5d86fd0a86332973412e4577f90344f.svg";